import React, {useEffect, useRef, useState} from "react";
import {Accordion, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import "./index.css";
import {useDispatch, useSelector} from "react-redux";
import Dropdown from "../../../_components/primer/Dropdown";
import {formEventToObjectConvertor,} from "../../../_helpers/helperFunctions";
import DateBox from "../DateBox";
import EditableTable from "../Editable-Table";
import Input from "../../common/Input";
import moment from "moment";
import {
    fetchAccountingAccountSearch,
    fetchAccountingRecordSearch,
    fetchAdvancedTypesSearch,
    fetchBankAccounts,
    fetchBasicTypesSearch,
    fetchBuysSearch,
    fetchCashRegisters,
    fetchClientMovementsSearch,
    fetchClientPaymentsSearch,
    fetchClientSearch, fetchDcls,
    fetchEmployeeSearch, fetchFixedAssetMovements, fetchFixedAssetRecords, fetchFixedAssets,
    fetchPOS,
    fetchPrescriptionsReferrals,
    fetchPrescriptionsSearch,
    fetchProductMovementsSearch,
    fetchProductPriceListSearch,
    fetchProductSearch, fetchQuotationsSearch,
    fetchSalesSearch,
    fetchSearchDrugs, fetchSearchExams,
    fetchSearchICD10s,
    fetchSupplierMovementsSearch,
    fetchSupplierPaymentsSearch,
    fetchSupplierSearch,
    fetchVisitsSearch,
    fetchWorkMovementsSearch,
    fetchWorkPermitsSearch, searchCheques, searchLoans,
    sendFilteredToMyDataApi,
    fetchSubmittedVatDeclarations,
    fetchSubmittedF4Declarations, fetchSubmittedF5Declarations,
    fetchUnregulatedDebts, searchCards
} from "../../../_apis/api";
import {toast} from "react-toastify";
import {
    checkPermission,
    clearEmptyValuesFromObject,
    getDefaultOptionByValue,
    getMultiSelectOptionsToArray,
    getSavedHiddenColumns,
    isEmpty,
} from "../../../_helpers/commonFunctions";
import {
    setAccordionOpen,
    setActivePage,
    setFilters,
    setForceRefresh,
    setSortOptions
} from "../../../_reducers/SearchTableSlice";
import DateHelper from "../DateHelper/DateHelper";
import BetterCheckBox from "../../common/BetterCheckBox";
import {setUserSettings} from "../../../_reducers/companySlice";
import Pagination from "../Pagination";
import {FaFileContract} from "react-icons/fa6";
import BankConnectModal from "../../layouts/data-panel/Banking/BankConnectModal";
import BankNotifyClientModal from "../../layouts/data-panel/Banking/BankNotifyClientModal";
import {IoNotificationsCircleSharp} from "react-icons/io5";
import {useTranslation} from "../../../hooks/useTranslation";

const SearchTable = (props) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const [searchTableColumns, setSearchTableColumns] = useState(null);
    let {filtersConfig, hideYearFilter} = props;
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const userSettings = useSelector((state) => state.COMPANY_DATA.userSettings);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const CASH_DATA = useSelector((state) => state.CASH_DATA);
    const SUPPLIERS_DATA = useSelector((state) => state.SUPPLIERS_DATA);
    const ACCOUNTING_DATA = useSelector((state) => state.ACCOUNTING_DATA);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const SALES = useSelector((state) => state.SALES);
    const BUYS = useSelector((state) => state.BUYS);
    const SEARCH_TABLE = useSelector((state) => state.SEARCH_TABLE);
    const PAYROLL = useSelector((state) => state.PAYROLL);
    const PRESCRIPTION = useSelector((state) => state.PRESCRIPTION);
    const DCL = useSelector((state) => state.DCL);
    const FIXED_ASSETS = useSelector((state) => state.FIXED_ASSETS);

    const [accordionOpen, setSTAccordionOpen] = useState(isEmpty(SEARCH_TABLE?.accordionOpen[props.tableName]) || SEARCH_TABLE?.accordionOpen[props.tableName] === true);
    const [showLoader, setShowLoader] = useState(false);
    const isVatDeclarations =
        props.tableName === "Submitted Vat Declarations Search" ||
        props.tableName === "Submitted F4 Declarations Search" ||
        props.tableName === "Submitted F5 Declarations Search" ||
        props.tableName === "Unregulated Debts Search";
    const selectedCompanyYear = company?.year || moment().format("YYYY");

    let defaultStartDate = isVatDeclarations
        ? moment(`${selectedCompanyYear}-01-01`, "YYYY-MM-DD").format("DD/MM/YYYY")
        : moment().startOf("month").format("DD/MM/YYYY");

    if (SEARCH_TABLE.filters[props.tableName]?.date_from) {
        defaultStartDate = SEARCH_TABLE.filters[props.tableName].date_from;
    } else if (!isVatDeclarations && Number(moment().format("YYYY")) > Number(company?.year)) {
        let newMoment = moment().subtract(Number(moment().format("YYYY")) - Number(company.year), "years");
        defaultStartDate = newMoment.utc().startOf("year").format("DD/MM/YYYY");
    }

    let defaultEndDate = isVatDeclarations
        ? moment(`${selectedCompanyYear}-12-31`, "YYYY-MM-DD").format("DD/MM/YYYY")
        : moment().endOf("month").format("DD/MM/YYYY");

    if (SEARCH_TABLE.filters[props.tableName]?.date_to) {
        defaultEndDate = SEARCH_TABLE.filters[props.tableName].date_to;
    } else if (!isVatDeclarations && Number(moment().format("YYYY")) > Number(company?.year)) {
        let newMoment = moment().subtract(Number(moment().format("YYYY")) - Number(company.year), "years");
        defaultEndDate = newMoment.utc().endOf("year").format("DD/MM/YYYY");
    }

    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(defaultEndDate);
    const [tabCloseWarning, showTabCloseWarning] = useState(false);
    const [sendFilteredToMyDataResponse, setSendFilteredToMyDataResponse] = useState(false);
    const [showSendFilteredToMyDataResponse, setShowSendFilteredToMyDataResponse] = useState(false);
    const [loadingSendFiltered, setLoadingSendFiltered] = useState(false);
    const [formData, setFormData] = useState({isActive: "inActive", ...SEARCH_TABLE.filters[props.tableName]});
    const requestDataPage = {
        ...formData,
        page: SEARCH_TABLE.activePage[props.tableName] ? SEARCH_TABLE.activePage[props.tableName] : 1,
        company: company.id,
        year: company.year,
    }
    const formRef = useRef(null);

    const [showConnectBankModal, setShowConnectBankModal] = useState(false);
    const [showBankNotifyClientModal, setShowBankNotifyClientModal] = useState(false);
    const [defaultBankSelection, setDefaultBankSelection] = useState("");

    let tableButtons = {print: false, delete: true, export: false, edit: true}
    let searchTable = [];
    let totalItems = 0;
    let perPage = 0;
    if (props.tableName === "Search Products") {
        tableButtons = {
            print: false,
            delete: checkPermission("products-products/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = PRODUCTS_DATA.searchProducts;
        totalItems = PRODUCTS_DATA.totalItemsPS;
        perPage = PRODUCTS_DATA.perPagePS;
    } else if (props.tableName === "Employees Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("accounting-employees/search-delete", permissionsData) || checkPermission("payroll-employees/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = ACCOUNTING_DATA.searchEmployees;
        totalItems = ACCOUNTING_DATA.totalItemsES;
        perPage = ACCOUNTING_DATA.perPageES;
    } else if (props.tableName === "Accounting Account Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("accounting-accountingaccounts/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = ACCOUNTING_DATA.searchAccountingAccounts;
        totalItems = ACCOUNTING_DATA.totalItemsAAS;
        perPage = ACCOUNTING_DATA.perPageAAS;
    } else if (props.tableName === "Accounting Record Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("accounting-accountingrecords/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = ACCOUNTING_DATA.searchAccountingRecords;
        totalItems = ACCOUNTING_DATA.totalItemsAR;
        perPage = ACCOUNTING_DATA.perPageAR;
    } else if (props.tableName === "Submitted Vat Declarations Search") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        };
        searchTable = ACCOUNTING_DATA.submittedVatDeclarations || [];
        totalItems = ACCOUNTING_DATA.totalItemsSVD || 0;
        perPage = ACCOUNTING_DATA.perPageSVD || 20;
    } else if (props.tableName === "Submitted F4 Declarations Search") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        };
        searchTable = ACCOUNTING_DATA.submittedF4Declarations || [];
        totalItems = ACCOUNTING_DATA.totalItemsSF4 || 0;
        perPage = ACCOUNTING_DATA.perPageSF4 || 20;
    } else if (props.tableName === "Submitted F5 Declarations Search") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        };
        searchTable = ACCOUNTING_DATA.submittedF5Declarations || [];
        totalItems = ACCOUNTING_DATA.totalItemsSF5 || 0;
        perPage = ACCOUNTING_DATA.perPageSF5 || 20;
    } else if (props.tableName === "Unregulated Debts Search") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        };
        searchTable = ACCOUNTING_DATA.unregulatedDebts || [];
        totalItems = ACCOUNTING_DATA.totalItemsSUD || 0;
        perPage = ACCOUNTING_DATA.perPageSUD || 20;
    } else if (props.tableName === "Search Product Price List") {
        tableButtons = {
            print: false,
            delete: checkPermission("products-pricelist/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = PRODUCTS_DATA.searchProductPriceList;
        totalItems = PRODUCTS_DATA.totalItemsPP;
        perPage = PRODUCTS_DATA.perPagePP;
    } else if (props.tableName === "Search Product Movements") {
        tableButtons = {
            print: false,
            delete: checkPermission("products-productsmovements/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = PRODUCTS_DATA.searchProductMovements;
        totalItems = PRODUCTS_DATA.totalItemsPM;
        perPage = PRODUCTS_DATA.perPagePM;
    } else if (props.tableName === "Client Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("clients-clients/search-delete", permissionsData),
            export: false,
            edit: false,
            showContactPoints: true
        }
        searchTable = CLIENTS_DATA.searchClients;
        totalItems = CLIENTS_DATA.totalItemsCS;
        perPage = CLIENTS_DATA.perPageCS;
    } else if (props.tableName === "Supplier Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("suppliers-suppliers/search-delete", permissionsData),
            export: false,
            edit: false,
            showContactPoints: true
        }
        searchTable = SUPPLIERS_DATA.searchSuppliers;
        totalItems = SUPPLIERS_DATA.totalItemsSSS;
        perPage = SUPPLIERS_DATA.perPageSSS;
    } else if (props.tableName === "Client Movements Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("clients-clientmovements/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CLIENTS_DATA.searchClientMovements;
        totalItems = CLIENTS_DATA.totalItemsCMS;
        perPage = CLIENTS_DATA.perPageCMS;
    } else if (props.tableName === "Supplier Movements Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("suppliers-suppliermovements/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = SUPPLIERS_DATA.searchSupplierMovements;
        totalItems = SUPPLIERS_DATA.totalItemsSMSS
        perPage = SUPPLIERS_DATA.perPageSMSS
    } else if (props.tableName === "Basic Types Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("settings-documenttype/basictypessearch-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = SETTINGS.searchBasicTypes;
        totalItems = SETTINGS.totalItemsBTS;
        perPage = SETTINGS.perPageBTS;
        tableButtons = {
            print: false,
            delete: true,
            export: false,
            edit: false
        }
    } else if (props.tableName === "Advanced Types Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("settings-documenttype/advancedtypessearch-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = SETTINGS.searchAdvancedTypes;
        totalItems = SETTINGS.totalItemsATS;
        perPage = SETTINGS.perPageATS;
    } else if (props.tableName === "Sales Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("sales-sales/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = SALES.searchSales;
        totalItems = SALES.totalItemsSS;
        perPage = SALES.perPageSS;
    } else if (props.tableName === "Quotations Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("sales-quotations/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = SALES.searchQuotations;
        totalItems = SALES.totalItemsQQ;
        perPage = SALES.perPageQQ;
    } else if (props.tableName === "Buys Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("buys-buy/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = BUYS.searchBuys;
        totalItems = BUYS.totalItemsBS;
        perPage = BUYS.perPageBS;
    } else if (props.tableName === "Cash Registers Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("cash-cashregisters/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CASH_DATA.searchCashRegisters;
    } else if (props.tableName === "POS Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("cash-pos/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CASH_DATA.searchPOS;
    } else if (props.tableName === "Cheques Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("cash-cheques/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CASH_DATA.chequeSearchData;
        totalItems = CASH_DATA.chequeSearchTotalItems;
        perPage = 20;
    } else if (props.tableName === "Loans Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("cash-loans/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CASH_DATA.searchLoans;
        totalItems = CASH_DATA.loanSearchTotalItems;
        perPage = 20;
    } else if (props.tableName === "Bank Account Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("cash-bankaccounts/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CASH_DATA.searchBankAccounts;
    } else if (props.tableName === "Client Payments Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("sales-clientpayments/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CLIENTS_DATA.searchClientPayments;
        totalItems = CLIENTS_DATA.totalItemsCPS;
        perPage = CLIENTS_DATA.perPageCPS;
    } else if (props.tableName === "Supplier Payments Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("buys-supplierpayments/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = SUPPLIERS_DATA.searchSupplierPayments;
        totalItems = SUPPLIERS_DATA.totalItemsSPS
        perPage = SUPPLIERS_DATA.perPageSPS
    } else if (props.tableName === "Work Movements Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("payroll-workmovements/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = PAYROLL.searchWorkMovements;
        totalItems = PAYROLL.totalItemsWM;
        perPage = PAYROLL.perPageWM;
    } else if (props.tableName === "Work Permits Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("payroll-workpermits/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = PAYROLL.searchWorkPermits;
        totalItems = PAYROLL.totalItemsWP;
        perPage = PAYROLL.perPageWP;
    } else if (props.tableName === "Prescription Search Visits") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = PRESCRIPTION.searchVisits;
        totalItems = PRESCRIPTION.totalItemsV;
        perPage = PRESCRIPTION.perPageV;
    } else if (props.tableName === "Prescription Search Prescriptions") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = PRESCRIPTION.searchPrescriptions;
        totalItems = PRESCRIPTION.totalItemsP;
        perPage = PRESCRIPTION.perPageP;
    } else if (props.tableName === "Prescription Search Referrals") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = PRESCRIPTION.searchReferrals;
        totalItems = PRESCRIPTION.totalItemsR;
        perPage = PRESCRIPTION.perPageR;
    } else if (props.tableName === "Prescription Search ICD10s") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = PRESCRIPTION.searchICD10s;
        totalItems = PRESCRIPTION.totalItemsICD10s;
        perPage = PRESCRIPTION.perPageICD10s;
    } else if (props.tableName === "Prescription Search Drugs") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = PRESCRIPTION.searchDrugs;
        totalItems = PRESCRIPTION.totalItemsDrugs;
        perPage = PRESCRIPTION.perPageDrugs;
    } else if (props.tableName === "Prescription Search Exams") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = PRESCRIPTION.searchExams;
        totalItems = PRESCRIPTION.totalItemsExams;
        perPage = PRESCRIPTION.perPageExams;
    } else if (props.tableName === "Dcl Search") {
        tableButtons = {
            print: false,
            delete: false,
            export: false,
            edit: false,
        }
        searchTable = DCL.searchDcl;
        totalItems = DCL.totalItemsDcl;
        perPage = DCL.perPageDcl;
    } else if (props.tableName === "Fixed Assets Search") {
        tableButtons = {
            print: false,
            delete: true,
            export: false,
            edit: false,
        }
        searchTable = FIXED_ASSETS.searchFixedAssets;
        totalItems = FIXED_ASSETS.totalItemsFA;
        perPage = FIXED_ASSETS.perPageFA;
    } else if (props.tableName === "Fixed Asset Movements Search") {
        tableButtons = {
            print: false,
            delete: true,
            export: false,
            edit: false,
        }
        searchTable = FIXED_ASSETS.searchFixedAssetMovements;
        totalItems = FIXED_ASSETS.totalItemsFAM;
        perPage = FIXED_ASSETS.perPageFAM;
    } else if (props.tableName === "Fixed Asset Records Search") {
        tableButtons = {
            print: false,
            delete: true,
            export: false,
            edit: false,
        }
        searchTable = FIXED_ASSETS.searchFixedAssetRecords;
        totalItems = FIXED_ASSETS.totalItemsFAR;
        perPage = FIXED_ASSETS.perPageFAR;
    } else if (props.tableName === "Cards Search") {
        tableButtons = {
            print: false,
            delete: checkPermission("cash-cards/search-delete", permissionsData),
            export: false,
            edit: false,
        }
        searchTable = CASH_DATA.searchCards;
        totalItems = CASH_DATA.searchCardsTotalItems;
        perPage = 20;
    }

    const sendFilteredToMyData = () => {
        showTabCloseWarning(false);
        let type = "sale";
        if (props.tableName === "Buys Search") type = "buy";
        if (props.tableName === "Accounting Record Search") type = "accounting";

        const filterObject = {...formData};
        if (type === "sale") {
            let requestData = {
                company: company.id,
                year: company.year,
                documentType: filterObject?.documentType, // array
                clientName: filterObject?.clientName,
                productName: filterObject?.productName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                preNumber_from: filterObject?.preNumber_from,
                preNumber_to: filterObject?.preNumber_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                paymentWay: filterObject?.paymentWay, // array
                myDataStatus: filterObject?.myDataStatus, // array
                providerChannel: filterObject?.providerChannel,
                paymentStatus: filterObject?.paymentStatus,
                notes: filterObject?.notes,
                date_from: startDate,
                date_to: endDate,
                anamorfosis_from: filterObject?.anamorfosis_from,
                anamorfosis_to: filterObject?.anamorfosis_to,
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(sendFilteredToMyDataApi(requestData, setSendFilteredToMyDataResponse, setShowSendFilteredToMyDataResponse, setLoadingSendFiltered, "sale"));
        } else if (type === "buy") {
            let requestData = {
                company: company.id,
                year: company.year,
                documentType: filterObject?.documentType, // array
                supplierName: filterObject?.supplierName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                preNumber_from: filterObject?.preNumber_from,
                preNumber_to: filterObject?.preNumber_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                paymentWay: filterObject?.paymentWay, // array
                myDataStatus: filterObject?.myDataStatus, // array
                notes: filterObject?.notes,
                date_from: startDate,
                date_to: endDate,
                productName: filterObject?.productName,
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(sendFilteredToMyDataApi(requestData, setSendFilteredToMyDataResponse, setShowSendFilteredToMyDataResponse, setLoadingSendFiltered, "buy"));
        } else if (type === "accounting") {
            let requestData = {
                company: company.id,
                year: company.year,
                documentType: filterObject?.documentType, // array
                category: filterObject?.category,
                subCategory: filterObject?.subCategory,
                subAccount: filterObject?.subAccount,
                subAccountName: filterObject?.subAccountName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                preNumber_from: filterObject?.preNumber_from,
                preNumber_to: filterObject?.preNumber_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                date_from: startDate,
                date_to: endDate,
                documentCreator: filterObject?.documentCreator,
                bridgedSection: filterObject?.bridgedSection,
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(sendFilteredToMyDataApi(requestData, setSendFilteredToMyDataResponse, setShowSendFilteredToMyDataResponse, setLoadingSendFiltered, "accounting"));
        }
    }

    const callbackCloseAccordion = () => {
        setShowLoader(false);
        if (accordionOpen) {
            setTimeout(() => {
                setSTAccordionOpen(false);
                dispatch(setAccordionOpen({...SEARCH_TABLE.accordionOpen, [props.tableName]: false}));
            }, 200)
        }
    }

    useEffect(() => {
        const columns = getSavedHiddenColumns(props.tableName, props.columns, userSettings);
        if (props.tableName === "Bank Account Search" && canNotifyForBanks()) {
            setDefaultBankSelection("");
            columns.push({
                name: "Ενέργειες λογιστή",
                field: "furtherActions",
                editable: true,
                inputType: {
                    type: 'button-sm',
                    config: {
                        disabled: false,
                        onClick: (rowData) => {
                            setDefaultBankSelection(rowData._id);
                            setShowBankNotifyClientModal(true);
                        },
                        text: "Ειδοποίηση διασύνδεσης",
                    }
                }
            })
        }
        setSearchTableColumns(columns);

        if (props.defaultSortOptions && props.defaultSortOptions.sortField) {
            dispatch(setSortOptions({
                ...SEARCH_TABLE.sortOptions,
                [props.tableName]: {
                    sortField: props.defaultSortOptions.sortField,
                    sortMethod: props.defaultSortOptions.sortMethod ?? "ASC"
                }
            }));
        }
    }, []);

    const [sortOptionsChanged, setSortOptionsChanged] = useState(false);

    useEffect(() => {
        if (sortOptionsChanged) {
            setSortOptionsChanged(false);
            handleOnSubmit(null, false);
        }
    }, [sortOptionsChanged]);

    useEffect(() => {
        if (searchTable?.length === 0) {
            if (!accordionOpen) {
                setSTAccordionOpen(true);
                dispatch(setAccordionOpen({...SEARCH_TABLE.accordionOpen, [props.tableName]: true}));
            }
            if (showLoader) setShowLoader(false);
        }
    }, [searchTable]);

    useEffect(() => {
        if (
            props.tableName === "Submitted Vat Declarations Search" ||
            props.tableName === "Submitted F4 Declarations Search" ||
            props.tableName === "Submitted F5 Declarations Search" ||
            props.tableName === "Unregulated Debts Search"
        ) {
            handleOnSubmit(null, false);
        }
    }, []);

    // Filter The Products Data
    const handleOnSubmit = async (e, manageAccordion = true) => {
        const cb = manageAccordion ? callbackCloseAccordion : () => setShowLoader(false);
        setShowLoader(true);
        let filterObject = {...formData};
        if (e) {
            e.preventDefault();
            filterObject = formEventToObjectConvertor(e);
        }
        let page = SEARCH_TABLE.activePage[props.tableName] ? SEARCH_TABLE.activePage[props.tableName] : 1
        let requestData = {}
        if (e) {
            page = 1;
            if (SEARCH_TABLE.activePage[props.tableName] && SEARCH_TABLE.activePage[props.tableName] !== page) {
                dispatch(setActivePage({...SEARCH_TABLE.activePage, [props.tableName]: 1}));
            }
        }
        if (props.tableName === "Search Products") {
            requestData = {
                page: page,
                company: company.id,
                year: company.year,
                isActive: filterObject.isActive ? filterObject.isActive : '',
                productName: filterObject.productName ? filterObject.productName : '',
                productCode: filterObject.productCode ? filterObject.productCode : '',
                productCategory: filterObject.productCategory ? filterObject.productCategory : '',
                alternativeName: filterObject.alternativeName ? filterObject.alternativeName : '',
                alternativeCode: filterObject.alternativeCode ? filterObject.alternativeCode : '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchProductSearch(requestData, cb));
        } else if (props.tableName === "Search Product Price List") {
            requestData = {
                page: page,
                company: company.id,
                isActive: filterObject.isActive ? filterObject.isActive : '',
                name: filterObject.name ? filterObject.name : '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchProductPriceListSearch(requestData, cb));
        } else if (props.tableName === "Search Product Movements") {
            requestData = {
                page: page,
                company: company.id,
                year: company.year,
                isActive: 'active',
                documentType: formData.documentType ? formData.documentType : '',
                date_from: startDate,
                date_to: endDate,
                numberFrom: formData.numberFrom ?? '',
                numberTo: formData.numberTo ?? '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchProductMovementsSearch(requestData, cb));
        } else if (props.tableName === "Client Search") {
            requestData = {
                page: page,
                company: company.id,
                contactName: filterObject.contactName ? filterObject.contactName : '',
                category: filterObject.category ? filterObject.category : '',
                isActive: filterObject.isActive ? filterObject.isActive : '',
                clientName: filterObject.clientName ? filterObject.clientName : '',
                vatNumber: filterObject.vatNumber ? filterObject.vatNumber : '',
                phone: filterObject.phone ? filterObject.phone : '',
                email: filterObject.email ? filterObject.email : '',
                systemCode: filterObject.systemCode ? filterObject.systemCode : '',
                manualCode: filterObject.manualCode ? filterObject.manualCode : '',
                contactDateFrom: filterObject.contactDateFrom ? filterObject.contactDateFrom : '',
                tags: filterObject.tags || [],
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchClientSearch(requestData, cb));
        } else if (props.tableName === "Employees Search") {
            requestData = {
                page: page,
                company: company.id,
                firstName: filterObject.firstName ? filterObject.firstName : '',
                lastName: filterObject.lastName ? filterObject.lastName : '',
                installation: filterObject.installation ? filterObject.installation : '',
                vatNumber: filterObject.vatNumber ? filterObject.vatNumber : '',
                employmentDate: filterObject.employmentDate ? filterObject.employmentDate : '',
                employeeType: filterObject.employeeType ? filterObject.employeeType : '',
                isActive: filterObject.isActive ? filterObject.isActive : '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchEmployeeSearch(requestData, cb));
        } else if (props.tableName === "Accounting Account Search") {
            requestData = {
                page: page,
                company: company.id,
                name: filterObject.name ? filterObject.name : '',
                code: filterObject.code ? filterObject.code : '',
                alternativeName: filterObject.alternativeName ? filterObject.alternativeName : '',
                category: formData.category ? formData.category : '',
                subAccount: formData.subAccount ? formData.subAccount : '',
                isActive: filterObject.isActive ? filterObject.isActive : '',
                movable: filterObject.movable ? filterObject.movable : '',
                transferable: filterObject.transferable ? filterObject.transferable : '',
                logisticOptions: filterObject.logisticOptions ? filterObject.logisticOptions : '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchAccountingAccountSearch(requestData, cb));
        } else if (props.tableName === "Supplier Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                category: filterObject.category ? filterObject.category : '',
                isActive: filterObject.isActive ? filterObject.isActive : '',
                name: filterObject.name ? filterObject.name : '',
                systemCode: filterObject.systemCode ? filterObject.systemCode : '',
                manualCode: filterObject.manualCode ? filterObject.manualCode : '',
                tags: filterObject.tags || [],
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSupplierSearch(requestData, cb));
        } else if (props.tableName === "Client Movements Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                name: filterObject.name ? filterObject.name : '',
                documentType: formData.documentType ? formData.documentType : '',
                sum_from: filterObject.sum_from ? filterObject.sum_from : '',
                sum_to: filterObject.sum_to ? filterObject.sum_to : '',
                date_from: startDate,
                date_to: endDate,
                numberFrom: formData.numberFrom ? formData.numberFrom : '',
                numberTo: formData.numberTo ? formData.numberTo : '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchClientMovementsSearch(requestData, cb));
        } else if (props.tableName === "Supplier Movements Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                name: filterObject.name ? filterObject.name : '',
                documentType: formData.documentType ? formData.documentType : '',
                sum_from: filterObject.sum_from ? filterObject.sum_from : '',
                sum_to: filterObject.sum_to ? filterObject.sum_to : '',
                date_from: startDate,
                date_to: endDate,
                numberFrom: formData.numberFrom ? formData.numberFrom : '',
                numberTo: formData.numberTo ? formData.numberTo : '',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData); // clear empty values before sending to the api.
            dispatch(fetchSupplierMovementsSearch(requestData, cb));
        } else if (props.tableName === "Basic Types Search") {
            requestData = {
                page: page,
                company: company.id,
                name: filterObject.name ? filterObject.name : '',
                affects_inventory: filterObject.affects_inventory ? filterObject.affects_inventory : '',
                affects_client: filterObject.affects_client ? filterObject.affects_client : '',
                affects_supplier: filterObject.affects_supplier ? filterObject.affects_supplier : '',
                isActive: "active",
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchBasicTypesSearch(requestData, cb));
        } else if (props.tableName === "Advanced Types Search") {
            requestData = {
                page: page,
                company: company.id,
                year: company.year,
                name: filterObject.name ? filterObject.name : '',
                section: filterObject.section ? filterObject.section : '',
                documentType: filterObject.basicDocumentType ? filterObject : '',
                isActive: filterObject.isActive ? filterObject.isActive : 'inActive',
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchAdvancedTypesSearch(requestData, cb));
        } else if (props.tableName === "Cash Registers Search") {
            requestData = {
                company: company.id,
                name: filterObject.name ? filterObject.name : '',
                serialNumber: filterObject.serialNumber ? filterObject.serialNumber : '',
                showInactive: filterObject.showInactive ? filterObject.showInactive : false,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchCashRegisters(requestData, cb));
        } else if (props.tableName === "POS Search") {
            requestData = {
                company: company.id,
                name: filterObject.name ? filterObject.name : '',
                serialNumber: filterObject.serialNumber ? filterObject.serialNumber : '',
                showInactive: filterObject.showInactive ? filterObject.showInactive : false,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchPOS(requestData, cb));
        } else if (props.tableName === "Cheques Search") {
            requestData = {
                page: page,
                company: company.id,
                numbering: filterObject.numbering ? filterObject.numbering : '',
                entityName: filterObject.entityName ? filterObject.entityName : '',
                amountFrom: filterObject.amountFrom || "",
                amountTo: filterObject.amountTo || "",
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(searchCheques(requestData, cb));
        } else if (props.tableName === "Loans Search") {
            requestData = {
                page: page,
                company: company.id,
                numbering: filterObject.numbering ? filterObject.numbering : '',
                principalFrom: filterObject.principalFrom || "",
                principalTo: filterObject.principalTo || "",
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(searchLoans(requestData, cb));
        } else if (props.tableName === "Bank Account Search") {
            requestData = {
                company: company.id,
                name: filterObject.name ? filterObject.name : '',
                iban: filterObject.iban ? filterObject.iban : '',
                bankName: filterObject.bankName ? filterObject.bankName : '',
                showInactive: filterObject.showInactive ? filterObject.showInactive : false,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchBankAccounts(requestData, cb));
        } else if (props.tableName === "Sales Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                documentType: filterObject?.documentType, // array
                clientName: filterObject?.clientName,
                productName: filterObject?.productName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                preNumber_from: filterObject?.preNumber_from,
                preNumber_to: filterObject?.preNumber_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                paymentWay: filterObject?.paymentWay, // array
                myDataStatus: filterObject?.myDataStatus, // array
                providerChannel: filterObject?.providerChannel,
                paymentStatus: filterObject?.paymentStatus,
                notes: filterObject?.notes,
                date_from: startDate,
                date_to: endDate,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSalesSearch(requestData, cb));
        } else if (props.tableName === "Quotations Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                documentType: filterObject?.documentType, // array
                clientName: filterObject?.clientName,
                productName: filterObject?.productName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                notes: filterObject?.notes,
                status: filterObject?.status,
                date_from: startDate,
                date_to: endDate,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchQuotationsSearch(requestData, cb));
        } else if (props.tableName === "Accounting Record Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                documentType: filterObject?.documentType, // array
                category: filterObject?.category,
                subCategory: filterObject?.subCategory,
                subAccount: filterObject?.subAccount,
                subAccountName: filterObject?.subAccountName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                preNumber_from: filterObject?.preNumber_from,
                preNumber_to: filterObject?.preNumber_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                date_from: startDate,
                date_to: endDate,
                documentCreator: filterObject?.documentCreator,
                bridgedSection: filterObject?.bridgedSection,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchAccountingRecordSearch(requestData, cb));
        } else if (props.tableName === "Buys Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                documentType: filterObject?.documentType, // array
                supplierName: filterObject?.supplierName,
                productName: filterObject?.productName,
                totalSum_from: filterObject?.totalSum_from,
                totalSum_to: filterObject?.totalSum_to,
                preNumber_from: filterObject?.preNumber_from,
                preNumber_to: filterObject?.preNumber_to,
                number_from: filterObject?.number_from,
                number_to: filterObject?.number_to,
                paymentWay: filterObject?.paymentWay, // array
                myDataStatus: filterObject?.myDataStatus, // array
                notes: filterObject?.notes,
                date_from: startDate,
                date_to: endDate,
                anamorfosis_from: filterObject?.anamorfosis_from,
                anamorfosis_to: filterObject?.anamorfosis_to,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchBuysSearch(requestData, cb));
        } else if (props.tableName === "Client Payments Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                clientName: filterObject?.clientName,
                documentType: formData?.documentType,
                paymentWay: formData?.paymentTypes,
                amount_from: filterObject?.amount_from,
                amount_to: filterObject?.amount_to,
                date_from: startDate,
                date_to: endDate,
                numberFrom: formData?.numberFrom,
                numberTo: formData?.numberTo,
                notes: filterObject?.notes,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchClientPaymentsSearch(requestData, cb));
        } else if (props.tableName === "Supplier Payments Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                supplierName: filterObject?.supplierName,
                documentType: filterObject?.documentType,
                paymentWay: filterObject?.paymentTypes,
                amount_from: filterObject?.amount_from,
                amount_to: filterObject?.amount_to,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSupplierPaymentsSearch(requestData, cb));
        } else if (props.tableName === "Work Movements Search") {
            requestData = {
                company: company.id,
                page: page,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                identifier: filterObject.identifier,
                //installationMasterId: filterObject.installationMasterId,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchWorkMovementsSearch(requestData, cb));
        } else if (props.tableName === "Work Permits Search") {
            requestData = {
                company: company.id,
                page: page,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                installationMasterId: filterObject.installationMasterId,
                erganiProtocol: filterObject.erganiProtocol,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchWorkPermitsSearch(requestData, cb));
        } else if (props.tableName === "Prescription Search Visits") {
            requestData = {
                company: company.id,
                page: page,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                amka: filterObject.amka,
                inQuota: filterObject.inQuota,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchVisitsSearch(requestData, cb));
        } else if (props.tableName === "Prescription Search Prescriptions") {
            requestData = {
                company: company.id,
                page: page,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                amka: filterObject.amka,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchPrescriptionsSearch(requestData, cb));
        } else if (props.tableName === "Prescription Search Referrals") {
            requestData = {
                company: company.id,
                page: page,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                amka: filterObject.amka,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchPrescriptionsReferrals(requestData, cb));
        } else if (props.tableName === "Prescription Search ICD10s") {
            requestData = {
                company: company.id,
                page: page,
                filter: filterObject.filter,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSearchICD10s(requestData, cb));
        } else if (props.tableName === "Prescription Search Drugs") {
            requestData = {
                company: company.id,
                page: page,
                general: filterObject.general,
                producer: filterObject.producer,
                activeSubstance: filterObject.activeSubstance,
                special: filterObject.special,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSearchDrugs(requestData, cb));
        } else if (props.tableName === "Prescription Search Exams") {
            requestData = {
                company: company.id,
                page: page,
                filter: filterObject.filter,
                codeEdapi: filterObject.codeEdapi,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSearchExams(requestData, cb));
        } else if (props.tableName === "Dcl Search") {
            requestData = {
                company: company.id,
                page: page,
                clientName: filterObject.clientName,
                date_from: filterObject.date_from,
                date_to: filterObject.date_to,
                vehicleRegistrationNumber: filterObject.vehicleRegistrationNumber,
                vehicleCategory: filterObject.vehicleCategory, //array
                documentType: filterObject.documentType, //array
                installation: filterObject.installation,
                clientServiceType: filterObject.clientServiceType,
                serviceCategory: filterObject.serviceCategory, //array
                providedServiceCategory: filterObject.providedServiceCategory, //array
                amount_from: filterObject.amount_from,
                amount_to: filterObject.amount_to,
                status: filterObject.status, //array
                notes: filterObject.notes,
                transmissionFailure: filterObject.transmissionFailure,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchDcls(requestData, cb));
        } else if (props.tableName === "Fixed Assets Search") {
            requestData = {
                company: company.id,
                page: page,
                identifier: filterObject.identifier,
                category: filterObject.category,
                acquisitionCost_from: filterObject.acquisitionCost_from,
                acquisitionCost_to: filterObject.acquisitionCost_to,
                notes: filterObject.notes,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchFixedAssets(requestData, cb));
        } else if (props.tableName === "Fixed Asset Movements Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                date_from: startDate,
                date_to: endDate,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
                identifier: filterObject.identifier,
                number_from: filterObject.number_from,
                number_to: filterObject.number_to,
                totalSum_from: filterObject.totalSum_from,
                totalSum_to: filterObject.totalSum_to,
                preNumber_from: filterObject.number_from,
                preNumber_to: filterObject.number_to,
                documentType: filterObject.documentType,
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchFixedAssetMovements(requestData, cb));
        } else if (props.tableName === "Fixed Asset Records Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                date_from: startDate,
                date_to: endDate,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
                identifier: filterObject.identifier,
                myDataStatus: filterObject.myDataStatus,
                number_from: filterObject.number_from,
                number_to: filterObject.number_to,
                totalSum_from: filterObject.totalSum_from,
                totalSum_to: filterObject.totalSum_to,
                preNumber_from: filterObject.number_from,
                preNumber_to: filterObject.number_to,
                documentType: filterObject.documentType,
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchFixedAssetRecords(requestData, cb));
        } else if (props.tableName === "Submitted Vat Declarations Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                month: formData?.month,
                declarationType: formData?.declarationType,
                submissionDate_from: startDate,
                submissionDate_to: endDate,
                date_from: startDate,
                date_to: endDate,
                field_311_from: filterObject?.field_311_from,
                field_311_to: filterObject?.field_311_to,
                field_367_from: filterObject?.field_367_from,
                field_367_to: filterObject?.field_367_to,
                field_470_from: filterObject?.field_470_from,
                field_470_to: filterObject?.field_470_to,
                field_480_from: filterObject?.field_480_from,
                field_480_to: filterObject?.field_480_to,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            };
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSubmittedVatDeclarations(requestData, cb));
        } else if (props.tableName === "Submitted F4 Declarations Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                month: formData?.month,
                declarationType: formData?.declarationType,
                submissionDate_from: startDate,
                submissionDate_to: endDate,
                date_from: startDate,
                date_to: endDate,
                total_bc5_from: filterObject?.total_bc5_from,
                total_bc5_to: filterObject?.total_bc5_to,
                total_bc6_from: filterObject?.total_bc6_from,
                total_bc6_to: filterObject?.total_bc6_to,
                total_bc7_from: filterObject?.total_bc7_from,
                total_bc7_to: filterObject?.total_bc7_to,
                total_bc8_from: filterObject?.total_bc8_from,
                total_bc8_to: filterObject?.total_bc8_to,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            };
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSubmittedF4Declarations(requestData, cb));
        } else if (props.tableName === "Submitted F5 Declarations Search") {
            requestData = {
                company: company.id,
                year: company.year,
                page: page,
                month: formData?.month,
                declarationType: formData?.declarationType,
                submissionDate_from: startDate,
                submissionDate_to: endDate,
                date_from: startDate,
                date_to: endDate,
                total_bc5_from: filterObject?.total_bc5_from,
                total_bc5_to: filterObject?.total_bc5_to,
                total_bc6_from: filterObject?.total_bc6_from,
                total_bc6_to: filterObject?.total_bc6_to,
                total_bc7_from: filterObject?.total_bc7_from,
                total_bc7_to: filterObject?.total_bc7_to,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            };
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchSubmittedF5Declarations(requestData, cb));
        } else if (props.tableName === "Unregulated Debts Search") {
            const selectedTaxYear = filterObject?.taxYear === "ALL" ? "" : filterObject?.taxYear;
            const selectedStatus = filterObject?.status === "ALL" ? "" : filterObject?.status;
            requestData = {
                company: company.id,
                page: page,
                assessment_date_from: startDate,
                assessment_date_to: endDate,
                date_from: startDate,
                date_to: endDate,
                status: selectedStatus,
                taxType: filterObject?.taxType,
                taxYear: selectedTaxYear,
                doy: filterObject?.doy,
                total_amount_from: filterObject?.total_amount_from,
                total_amount_to: filterObject?.total_amount_to,
                sortOptions: SEARCH_TABLE.sortOptions[props.tableName],
            };
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(fetchUnregulatedDebts(requestData, cb));
        } else if (props.tableName === "Cards Search") {
            requestData = {
                company: company.id,
                page: page,
                name: filterObject?.name,
                numbering: filterObject?.numbering,
            }
            requestData = clearEmptyValuesFromObject(requestData);
            dispatch(searchCards(requestData, cb));
        }

        if (e) toast.info('Loading search result...');
        setFormData(filterObject);

        const filters = {...requestData};
        dispatch(setFilters({...SEARCH_TABLE.filters, [props.tableName]: filters}));
    };

    const handleOnFilterChange = (e, type = "default", ddname = '') => {
        let name;
        let value;
        if (type === 'msdd') {
            name = ddname;
            value = getMultiSelectOptionsToArray(e);
        } else if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (ddname === "showInactive") {
            value = e.target.checked;
            name = ddname;
        } else if (type === 'cb') {
            value = e.target.checked ? 'active' : 'inActive';
            name = ddname;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        setFormData({...formData, [name]: value});
    }

    const [firstLoad, setFirstLoad] = useState(true);
    const handlePageChange = (page) => {
        dispatch(setActivePage({...SEARCH_TABLE.activePage, [props.tableName]: page}));
    }
    const handleAfterDelete = () => {
        handleOnSubmit(null, false);
    }
    useEffect(() => {
        let load = false;
        if (firstLoad) {
            setFirstLoad(false);
            if (SEARCH_TABLE.forceRefresh[props.tableName] === true) {
                dispatch(setForceRefresh({...SEARCH_TABLE.forceRefresh, [props.tableName]: false}));
                load = true;
            }
        } else {
            load = true;
        }
        if (load) handleOnSubmit(null, false);
    }, [SEARCH_TABLE.activePage])

    // table name → permission prefix for the apply filter button
    const permissionsMappingSearch = {
        "Search Products": "products-products/search",
        "Search Product Movements": "products-productsmovements/search",
        "Search Product Price List": "products-pricelist/search",
        "Sales Search": "sales-sales/search",
        "Quotations Search": "sales-quotations/search",
        "Client Payments Search": "sales-clientpayments/search",
        "Buys Search": "buys-buy/search",
        "Supplier Payments Search": "buys-supplierpayments/search",
        "Client Search": "clients-clients/search",
        "Client Movements Search": "clients-clientmovements/search",
        "Supplier Search": "suppliers-suppliers/search",
        "Supplier Movements Search": "suppliers-suppliermovements/search",
        "Cash Registers Search": "cash-cashregisters/search",
        "POS Search": "cash-pos/search",
        "Bank Account Search": "cash-bankaccounts/search",
        "Basic Types Search": "settings-documenttype/basictypessearch",
        "Advanced Types Search": "settings-documenttype/advancedtypessearch",
        "Accounting Account Search": "accounting-accountingaccounts/search",
        "Accounting Record Search": "accounting-accountingrecords/search",
        "Work Movements Search": "payroll-workmovements/search",
        "Work Permits Search": "payroll-workpermits/search",
        "Dcl Search": "sales-dcl/search",
        "Fixed Assets Search": "fixedassets-fixedassets/search",
        "Fixed Asset Movements Search": "fixedassets-movements/search",
        "Fixed Asset Records Search": "fixedassets-records/search",
        "Transfers Search": "sales-transfers/search",
        "Cheques Search": "cash-cheques/search",
        "Loans Search": "cash-loans/search",
        "Cards Search": "cash-cards/search",
        "Employees Search": ["accounting-employees/search", "payroll-employees/search"],
        "Submitted Vat Declarations Search": "accounting-forms/f2-read",
        "Submitted F4 Declarations Search": "accounting-forms/f4-read",
        "Submitted F5 Declarations Search": "accounting-forms/f5-read",
        "Unregulated Debts Search": "accounting-forms/debts-read"
    }

    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [searchTable])

    const constructMultiselectFromSelectedValues = (selected, options) => {
        let arr = [];
        if (selected && selected?.length > 0) {
            for (let opt of selected) {
                let filt = options.filter((el) => el.value === opt);
                if (filt.length > 0) {
                    arr.push({value: opt, label: filt[0].label});
                }
            }
        }
        return arr;
    }

    const handleAccordionClick = (e) => {
        setSTAccordionOpen(e.target.classList.value.includes("collapsed"));
        dispatch(setAccordionOpen({
            ...SEARCH_TABLE.accordionOpen,
            [props.tableName]: e.target.classList.value.includes("collapsed")
        }))
    }

    const handleDateFrom = (comingFrom, data) => {
        if (comingFrom === "dateHelper") {
            setStartDate(data); // DD/MM/YYYY format
        } else if (comingFrom === "dateBox") {
            setStartDate(moment(data).format("DD/MM/YYYY"));
        }
    }
    const handleDateTo = (comingFrom, data) => {
        if (comingFrom === "dateHelper") {
            setEndDate(data); // DD/MM/YYYY format
        } else if (comingFrom === "dateBox") {
            setEndDate(moment(data).format("DD/MM/YYYY"));
        }
    }

    const hasReadPermission = () => {
        const perm = permissionsMappingSearch[props.tableName];
        if (perm) {
            if (typeof perm === "string") {
                return checkPermission(perm + "-read", permissionsData);
            } else if (typeof perm === "object") {
                return perm.some((el) => checkPermission(el + "-read", permissionsData));
            }
        } else {
            return true;
        }
    }

    const hasPrintPermission = () => {
        const perm = permissionsMappingSearch[props.tableName];
        if (perm) {
            if (typeof perm === "string") {
                return checkPermission(perm + "-print", permissionsData);
            } else if (typeof perm === "object") {
                return perm.some((el) => checkPermission(el + "-print", permissionsData));
            }
        } else {
            return true;
        }
    }

    const handleUpdateUserSettings = (newSettings) => {
        dispatch(setUserSettings(newSettings));
    }

    const handleChangeSortMethod = (e, field) => {
        const oldOptions = SEARCH_TABLE.sortOptions[props.tableName];
        let sortMethod;
        if (field === "preNumberAndNumber") field = "number";

        if (oldOptions?.sortField === field && oldOptions?.sortMethod === "ASC") {
            sortMethod = "DESC";
        } else if (oldOptions?.sortField === field && oldOptions?.sortMethod === "DESC") {
            sortMethod = null;
        } else {
            sortMethod = "ASC";
        }
        if (!sortMethod) {
            dispatch(setSortOptions({
                ...SEARCH_TABLE.sortOptions,
                [props.tableName]: {}
            }));
        } else {
            // Special Case where table field does not match with model.
            if (field === "preNumberAndNumber") field = "number";
            dispatch(setSortOptions({
                ...SEARCH_TABLE.sortOptions,
                [props.tableName]: {
                    sortField: field,
                    sortMethod: sortMethod
                }
            }));
        }
        setSortOptionsChanged(true);
    }

    const canConnectBanks = () => {
        return checkPermission("custom-opseos", permissionsData);
    }

    const canNotifyForBanks = () => {
        return checkPermission("custom-sales", permissionsData) || checkPermission("custom-logistirio", permissionsData);
    }

    return (
        <div className="search-table">
            <form ref={formRef} onSubmit={(e) => handleOnSubmit(e)} autoComplete='off'>
                <Accordion activeKey={accordionOpen === true ? "0" : ""} className={"mb-2 custom-accordion"}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header
                            onClick={(e) => handleAccordionClick(e)}>{t('SearchTableIndex.filters')}</Accordion.Header>
                        <Accordion.Body>
                            {!hideYearFilter && (
                                <Row>
                                    <Col md={3}>
                                        <DateHelper
                                            dateFromFunction={(e) => handleDateFrom("dateHelper", e)}
                                            dateToFunction={(e) => handleDateTo("dateHelper", e)}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <DateBox
                                            name="date_from"
                                            selected={moment(startDate, "DD/MM/YYYY").isValid() ? moment(startDate, "DD/MM/YYYY").toDate() : ""}
                                            label={t('SearchTableIndex.dateFrom')}
                                            allowOtherYears={props.allowOtherYears || false}
                                            onChange={(e) => handleDateFrom("dateBox", e)}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <DateBox
                                            name="date_to"
                                            selected={moment(endDate, "DD/MM/YYYY").isValid() ? moment(endDate, "DD/MM/YYYY").toDate() : ""}
                                            label={t('SearchTableIndex.dateTo')}
                                            allowOtherYears={props.allowOtherYears || false}
                                            onChange={(e) => handleDateTo("dateBox", e)}
                                        />
                                    </Col>
                                </Row>
                            )}
                            <Row>
                                {filtersConfig && filtersConfig.filters.map((filter, i) => (
                                    <Col md={filter.mdWidth ? filter.mdWidth : 3} key={i}>
                                        <div className="search-box search-fields mb-2 b-inline-block">
                                            {(filter?.type === 'input' || filter?.type === 'text') &&
                                                <Input
                                                    type="text"
                                                    label={filter.label}
                                                    placeholder={`${filter.label}`}
                                                    name={filter.name}
                                                    defaultValue={formData[filter.name]}
                                                    autoComplete="off"
                                                    onBlur={(e) => handleOnFilterChange(e)}
                                                />
                                            }
                                            {filter?.type === 'number' &&
                                                <Input
                                                    type="number"
                                                    label={filter.label}
                                                    placeholder={`${filter.label}`}
                                                    name={filter.name}
                                                    defaultValue={formData[filter.name]}
                                                    onChange={(e) => handleOnFilterChange(e)}
                                                />
                                            }
                                            {filter?.type === 'date' &&
                                                <DateBox
                                                    label={filter.label}
                                                    placeholder={`${filter.label}`}
                                                    name={filter.name}
                                                    selected={moment(formData[filter.name], "DD-MM-YYYY").isValid() ?
                                                        moment(formData[filter.name], "DD-MM-YYYY").toDate() :
                                                        formData[filter.name] ? formData[filter.name] : ""}
                                                    allowOtherYears={!!filter?.allowOtherYears}
                                                    onChange={(e) => handleOnFilterChange(e, 'dp', filter.name)}
                                                />
                                            }
                                            {filter?.type === 'checkbox' &&
                                                <BetterCheckBox
                                                    name={filter.name}
                                                    text={filter.label}
                                                    className="mb-0 mr-2 mt-3 centered-checkbox"
                                                    checked={formData[filter.name] === "active"}
                                                    onChange={(e) => handleOnFilterChange(e, 'cb', filter.name)}
                                                />
                                            }
                                            {filter?.type === 'showInactiveCheckbox' &&
                                                <BetterCheckBox
                                                    name={filter.name}
                                                    text={filter.label}
                                                    className="mb-0 mr-2 mt-3 centered-checkbox"
                                                    checked={formData[filter.name]}
                                                    onChange={(e) => handleOnFilterChange(e, 'cb', filter.name)}
                                                />
                                            }
                                            {filter?.type === 'dropdown' &&
                                                <Dropdown
                                                    label={filter.label}
                                                    options={filter.options}
                                                    placeholder={`${filter.label}`}
                                                    name={filter.name}
                                                    value={formData[filter.name] ? getDefaultOptionByValue(filter.options, formData[filter.name], 'value', 'label', 'value') : ""}
                                                    enabledValue={true}
                                                    onChange={(e) => handleOnFilterChange(e, 'dd', filter.name)}
                                                />
                                            }
                                            {filter?.type === 'multiselect' &&
                                                <Dropdown
                                                    multiSelect={true}
                                                    label={filter.label}
                                                    options={filter.options}
                                                    placeholder={`${filter.label}`}
                                                    defaultValue={constructMultiselectFromSelectedValues(formData[filter.name], filter.options)}
                                                    name={filter.name}
                                                    onChange={(e) => handleOnFilterChange(e, 'msdd', filter.name)}
                                                />
                                            }
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Row>
                    {(filtersConfig || !hideYearFilter) &&
                        <Col md={12} style={{textAlign: "right"}} className={"mb-2"}>
                            {(props.tableName === "Bank Account Search" && canNotifyForBanks()) && (
                                <Button onClick={() => setShowBankNotifyClientModal(true)} className={"mr-2"}>
                                    <IoNotificationsCircleSharp size={18}/> Ειδοποίηση πελάτη για διασύνδεση τράπεζας
                                </Button>
                            )}
                            {(props.tableName === "Bank Account Search" && canConnectBanks()) && (
                                <Button onClick={() => setShowConnectBankModal(true)} className={"mr-2"}>
                                    <FaFileContract size={14}/> Νέα διασύνδεση
                                </Button>
                            )}
                            {((props?.tableName === "Sales Search" || props?.tableName === "Buys Search" || props?.tableName === "Accounting Record Search") && checkPermission("sales-sales/search-write", permissionsData)) &&
                                <Button disabled={loadingSendFiltered || showLoader}
                                        onClick={() => showTabCloseWarning(true)} className={"mr-2"}>
                                    {loadingSendFiltered && (
                                        <span className="spinner-border spinner-border-sm" role="status"
                                              aria-hidden="true"></span>)}
                                    {t('SearchTableIndex.sendFilteredToMyData')}
                                </Button>
                            }
                            {
                                props.tableName === "Unregulated Debts Search" && (
                                    <Button
                                        type="button"
                                        variant="primary"
                                        disabled={props.isScraping || showLoader}
                                        onClick={() => {
                                            if (typeof props.onSendEmailClick === 'function') {
                                                props.onSendEmailClick();
                                            }
                                        }}
                                        className={"mr-2"}
                                    >
                                        <i className="fa-solid fa-envelope fa-sm mr-2"></i>
                                        Αποστολή Email
                                    </Button>
                                )
                            }
                            {(
                                props.tableName === "Submitted Vat Declarations Search" ||
                                props.tableName === "Submitted F4 Declarations Search" ||
                                props.tableName === "Submitted F5 Declarations Search" ||
                                props.tableName === "Unregulated Debts Search"
                            ) && props.onScrapeClick && (
                                <Button
                                    type="button"
                                    variant="primary"
                                    disabled={props.isScraping || showLoader}
                                    onClick={() => {
                                        props.onScrapeClick({
                                            date_from: startDate,
                                            date_to: endDate,
                                            ...formData
                                        });
                                    }}
                                    className={"mr-2"}
                                >
                                    <i className="fa-solid fa-cloud-arrow-down fa-sm mr-2"></i>
                                    {props.scrapeButtonTitle || "Άντληση από Taxisnet"} {props.isScraping && (
                                    <Spinner className={"ml-2"} animation={"border"} size="sm" variant={"light"}/>
                                )}
                                </Button>
                            )}
                            {hasReadPermission() &&
                                <Button disabled={showLoader || props.isScraping} type="submit">
                                    {t('SearchTableIndex.applyFilter')} {showLoader && (
                                    <Spinner className={"ml-2"} animation={"border"} variant={"light"}/>)}
                                </Button>
                            }
                        </Col>
                    }
                </Row>
            </form>
            <Row>
                <Col className="d-flex justify-content-end">
                    {(totalItems !== 0 && searchTable?.length > 0) && (
                        <div className={"mr-3 mt-2"}><i>Σύνολο Αποτελεσμάτων: {totalItems}</i></div>)}
                    {props.allowPagination && searchTable?.length > 0 && (
                        <Pagination
                            currentPage={SEARCH_TABLE.activePage[props.tableName] ? SEARCH_TABLE.activePage[props.tableName] : 1}
                            totalPages={Math.ceil(totalItems / perPage)}
                            handlePageChange={(e) => handlePageChange(e)}
                            maxWidth={400}
                        />
                    )}
                </Col>
            </Row>
            {searchTableColumns && (
                <EditableTable
                    filterRowConfig={props.filterRowConfig}
                    allowFilterTable={false}
                    editRedirectAllowed={true}
                    tableName={props.tableName}
                    key={props.tableName + String(incrKey)}
                    actionButtons={tableButtons}
                    allowInsertRow={props.allowInsertRow ? props.allowInsertRow : false}
                    allowFilter={false}
                    allowPagination={false} // No need, we have new built in search table
                    allowBulkDelete={false}
                    allowBulkActions={true}
                    allowPrintResults={props.allowPrintResults ? String(props.tableName).includes("Search") ? hasPrintPermission() : props.allowPrintResults : false}
                    dataEndpoint={props.dataEndpoint}
                    exportFileName={props.exportFileName}
                    allowSorting={props.allowSorting !== undefined ? props.allowSorting : true}
                    allowSelectionCheckbox={props.allowSelectionCheckbox ? props.allowSelectionCheckbox : false} //props.allowSelectionCheckbox ? props.allowSelectionCheckbox : false
                    selectedRows={props?.selectedRows || null}
                    setSelectedRows={props?.setSelectedRows || null}
                    selectedRowKey={"_id"}
                    allowActions={true}
                    columns={searchTableColumns}
                    handleChangeSortMethod={(e, field) => handleChangeSortMethod(e, field)}
                    sortOptions={SEARCH_TABLE.sortOptions}
                    data={searchTable}
                    totalItems={totalItems}
                    perPage={perPage}
                    requestData={requestDataPage}
                    formData={formData}
                    allowToggleColumns={props.allowToggleColumns}
                    toggleColumns={props.toggleColumns}
                    enableNewRowCheckbox={props.enableNewRowCheckbox ? props.enableNewRowCheckbox : false}
                    handleUpdateUserSettings={(newSettings) => handleUpdateUserSettings(newSettings)}
                    companyDetails={companyDetails}
                    handleAfterDelete={() => handleAfterDelete()}
                    isSearchTable={true}
                />
            )}

            <Modal className="themeModal" show={tabCloseWarning}>
                <Modal.Header>
                    <Modal.Title>{t('SearchTableIndex.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('SearchTableIndex.message')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary"
                            onClick={() => showTabCloseWarning(false)}>{t('SearchTableIndex.no')}</Button>
                    <Button variant="primary" onClick={sendFilteredToMyData}>{t('SearchTableIndex.yes')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal className="themeModalBig" show={showSendFilteredToMyDataResponse}>
                <Modal.Header>
                    <Modal.Title>{t('SearchTableIndex.sendToMyDataReport')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('SearchTableIndex.message2')}<br/> {sendFilteredToMyDataResponse}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary"
                            onClick={() => setShowSendFilteredToMyDataResponse(false)}>OK</Button>
                </Modal.Footer>
            </Modal>

            {props.tableName === "Bank Account Search" && (
                <React.Fragment>
                    <BankConnectModal
                        show={showConnectBankModal}
                        setShow={setShowConnectBankModal}
                        successfulCallback={() => handleOnSubmit(null, false)}
                    />
                    <BankNotifyClientModal
                        show={showBankNotifyClientModal}
                        setShow={setShowBankNotifyClientModal}
                        defaultBankSelection={defaultBankSelection}
                        setDefaultBankSelection={setDefaultBankSelection}
                    />
                </React.Fragment>
            )}
        </div>
    )
}

export default SearchTable;
